import { fork } from 'redux-saga/effects';
import browserHistory from 'history/browser';
import { router } from '@onegini/redux-saga-router';

import analyticsService from '../../common/Services/AnalyticsService';

const ROOT_ROUTE = '';

const configureAnalyticsRoute = (path, area) => ({ path: `${ROOT_ROUTE}/${path}`, area });

const routeDefinitions = [
  ['console/dashboard', ['Dashboard']],
  ['admin/dashboard/index', ['Dashboard index']],
  ['console/experiences/overview/all', ['All experiences']],
  ['console/content/collections', ['Content collections']],
  ['console/content/collections/list', ['Content collections', 'List']],
  [
    'console/content/collections/:collectionId/:action?',
    ({ collectionId, action }) => ['Content collection', collectionId, ...(action ? [action] : [])],
  ],
  ['console/report', ['Report']],
  ['admin/report/index', ['Report Index']],
  ['console/experiencelibrary/home', ['App store', 'Home page']],
  ['console/experiencelibrary/category/:category', ({ category }) => ['App store', 'Home page', category]],
  ['console/experiencelibrary/account-templates', ['App store', 'Account Templates']],
  ['console/experiencelibrary/app/:app', ({ app }) => ['App store', 'App', app]],
  ['admin/resources/assets', ['Resources Assets']],
  ['admin/resources/assets/create', ['Create Assets', 'Create']],
  ['admin/resources/forms', ['Resources Forms']],
  ['admin/resources/forms/create', ['Resources Forms', 'Create']],
  ['admin/resources/themes', ['Resources Themes']],
  ['admin/resources/themes/create', ['Resources Themes', 'Create']],
  [
    'admin/campaign/show/:experienceId/:section/:subsection?',
    ({ experienceId, section, subsection }) => [
      'Experience workspace',
      `Experience Id ${experienceId}`,
      section,
      ...(subsection ? [subsection] : []),
    ],
  ],
  ['admin/account/edit', ['Account Settings']],
  ['admin/account/createUser', ['Create User']],
  ['admin/user/list', ['User List']],
  ['admin/user/edit', ['Edit User']],
  ['admin/user/forcechangepwd', ['Edit Password']],
  ['admin/account/tracking', ['Tracking']],
  ['admin/userauth/manage', ['Manage User Auth']],
  ['admin/account/integrations', ['Integrations']],
  ['admin/account/dataProtection', ['Data Protection']],
  ['admin/channel/show/:channelId', ['Channels']],
];

const trackedRoutes = routeDefinitions.map(([path, area]) => configureAnalyticsRoute(path, area));

const generateRoutes = (routes, analyticsService, browserHistory) =>
  routes.reduce((acc, route) => {
    acc[route.path] = function* (params = {}) {
      const segments = typeof route.area === 'function' ? route.area(params) : route.area;

      analyticsService.trackPage({
        type:             analyticsService.trackingTypes.ROUTE,
        route:            browserHistory.location.pathname,
        pageNameSegments: segments,
      });
    };
    return acc;
  }, {});

const routeHandlers = generateRoutes(trackedRoutes, analyticsService, browserHistory);

// for now this will ensure we bootstrap the app on each route
const options = {
  matchAll: false,
  *beforeRouteChange() {
    // you could just track all pages here...
    // analyticsService.trackPage({
    //   type:    analyticsService.trackingTypes.ROUTE,
    //   route:   browserHistory.getCurrentLocation(),
    //   message: 'tracking a route',
    // });
  },
};

export default function* analyticsSaga() {
  // register router saga
  yield fork(router, browserHistory, routeHandlers, options);
}
